import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { api } from '../lib/api.js';
import { StudioMark } from '../lib/branding.jsx';

/**
 * Wraps every admin screen: verifies the session once, bounces to the login
 * page on 401, and renders the top bar. Keeps auth handling out of each screen.
 */
export default function AdminShell({ children, title, actions }) {
  const [state, setState] = useState('checking');
  const navigate = useNavigate();

  useEffect(() => {
    api
      .get('/api/admin/me')
      .then(() => setState('ok'))
      .catch(() => navigate('/admin/login', { replace: true }));
  }, [navigate]);

  async function logout() {
    await api.post('/api/admin/logout');
    navigate('/admin/login', { replace: true });
  }

  if (state !== 'ok') return <div className="centered muted">Loading…</div>;

  return (
    <>
      <header className="topbar">
        <div className="topbar-inner">
          <Link to="/admin" style={{ textDecoration: 'none', color: 'inherit' }}>
            <StudioMark />
          </Link>
          <div className="row">
            {actions}
            <button className="ghost sm" onClick={logout}>
              Sign out
            </button>
          </div>
        </div>
      </header>
      <main className="shell">
        {title && <h1 style={{ marginBottom: '1rem' }}>{title}</h1>}
        {children}
      </main>
    </>
  );
}
